import React, { useEffect } from 'react';
import { FormGrid } from '../../toolympus/components/primitives';
import { PublicPageWrapper } from '../Common/PublicPageWrapper';
import { useEditItem2 } from '../../toolympus/api/useNewItem';
import { login, useUser } from '../../toolympus/userContext/UserContext';
import { useReturnUrl } from '../../toolympus/hooks/auth/useReturnUrl';
import { FormControlsForFields } from '../../toolympus/components/schemed';
import { Schema } from '../../toolympus/hooks/useSchema';
import { Button, Typography } from '@mui/material';
import { apiFetch } from '../../toolympus/api/core';
import { useHistory } from 'react-router-dom';
import { ICLRCAuthLogo } from './LoginKC';

interface Props {
  
}

const useLoginOtp = () => {
  const returnUrl = useReturnUrl();

  const userCtx = useUser();
  const history = useHistory();

  const data = useEditItem2<{ login: string, code: string, session_code: string, isCode: boolean }>({
    startWith: { login: "", code: "", session_code: "", isCode: false },
    dontResetOnSave: true,
    setToSaved: true,
    save: async (item) => {
      if(!item.isCode) {
        const result = await apiFetch<{ session_code: string }>("/api/login/otp/start", "post", { login: item.login });
        return { ...item, session_code: result.session_code, isCode: true };
      } else {
        const result = await apiFetch<string>("/api/login/otp/complete", "post", { login: item.login, session_code: item.session_code, code: item.code }, { noAuth: true });
        login(userCtx, result);
        history.push(returnUrl.fromParam || "/");
        return item;
      }
    }
  })

  useEffect(() => {
    const loginFromUrl = new URLSearchParams(window.location.search).get("login");
    if(loginFromUrl) {
      data.update({ login: loginFromUrl });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    ...data,
  }
}

const LoginSchema: Schema = {
  login: { label: "Email" },
  code: { label: "Код" },
}

export const LoginOTP = (props: Props) => {
  const data = useLoginOtp();
  
  return (
    <PublicPageWrapper>
      <form onSubmit={e => {
        e.preventDefault();
        data.save();
      }}>
        <FormGrid columns="300px">
          {!data.item?.isCode && <Typography color="textSecondary" style={{ textAlign: "center" }}>Введите вашу почту, чтобы получить код для входа</Typography>}
          {!!data.item &&
            <FormControlsForFields
              data={data.item}
              onChange={(o,c) => data.update(c)}
              schema={LoginSchema}
              fields={[
                ["login", { disabled: !!data.item.isCode, controlProps: { autoFocus: !data.item?.isCode, variant: "outlined" }}],
                data.item?.isCode ? ["code", { controlProps: { autoFocus: true, variant: "outlined" }}] : null,
              ]}
              />}
          {!!data.item?.isCode && <Typography color="textSecondary" style={{ textAlign: "center" }}>Код для входа отправлен на почту</Typography>}
          <Button color="primary" variant="contained" type="submit">войти</Button>
          <Button color="primary" href="/login-kc-start"><ICLRCAuthLogo /></Button>
          {/* <Button color="primary" href="/login-pass">войти по паролю</Button> */}
        </FormGrid>
      </form>
    </PublicPageWrapper>
  );
}
